import React from 'react';

/**
 * Sparkline SVG sem dependências externas. Para séries pequenas
 * (~12 valores). Renderiza uma minigrafico de linha com área levemente
 * preenchida. Ideal para mostrar tendência mensal em uma célula de tabela.
 *
 * Props:
 *   - data: number[] (obrigatório)
 *   - width / height: default 100x24
 *   - color: cor da linha (default azul-600 do Tailwind)
 *   - fillOpacity: 0..1 (default 0.15)
 */
const Sparkline = ({ data = [], width = 100, height = 24, color = '#2563eb', fillOpacity = 0.15 }) => {
  if (!data || data.length === 0) {
    return <div style={{ width, height }} className="text-gray-300 text-xs">∅</div>;
  }
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const range = max - min || 1;
  const stepX = data.length > 1 ? width / (data.length - 1) : 0;

  const points = data.map((v, i) => {
    const x = i * stepX;
    const y = height - ((v - min) / range) * height;
    return [x, y];
  });

  const pathLine = points.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ');
  const pathArea = `${pathLine} L${width},${height} L0,${height} Z`;

  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} className="inline-block">
      <path d={pathArea} fill={color} fillOpacity={fillOpacity} stroke="none" />
      <path d={pathLine} fill="none" stroke={color} strokeWidth="1.5" />
    </svg>
  );
};

export default Sparkline;
